<template>
	<div v-if="$store.state.showBannerLanding && isEventRogActive" class="GoldDripLanding fixed flex justify-center w-11/12 z-1050 pt-28">
		<div class="background fixed"></div>

		<div class="relative z-1100">
			<img src="@/assets/img/PopupbannerROG_JFXGOLDX.png" class="banner-promo">

			<span @click="close()">
				<IconButtonClose2 class="button-close cursor-pointer" />
			</span>
		</div>
	</div>
</template>

<script>
import { EVENT_KEYS } from '../internal/events'
import IconButtonClose2 from './icons/IconButtonClose2.vue'
export default {
	name: 'GoldDripLanding',
	components: {
		IconButtonClose2,
	},

	computed: {
		EVENT_KEYS() {
      return EVENT_KEYS
    },

		isEventRogActive() {
			const eventStatus = this.$store.getters['events/getEventStatus'](EVENT_KEYS.rog)

			return eventStatus == 'ongoing' ? true : false
		}
	},

	methods: {
		close() {
			this.$store.commit('setShowBannerLanding', false)
		},
	},

	created() {
		// fetch ROG event detail
		if (this.$store.getters.paymentMethod == 'rped') {
			this.$store.dispatch('events/fetchEvent', EVENT_KEYS.rog)
		}
	}
}
</script>

<style scoped>
.GoldDripLanding {
	position: fixed;
	top: 0;
}

.banner-promo {
	max-width: 58.75rem;
	width: 100%;
}

.background {
	background-color: rgba(0, 0, 0, 0.5);
	position: fixed;
	inset: 0;
	/* pointer-events: none; */
	/* opacity: 0.25; */
}

.button-close {
	position: absolute;
	top: -1rem;
	right: -1rem;
}
</style>